import { AccordionSummary, styled } from '@mui/material';
import { ThemeMode } from 'ci-esi-web-shared';

import { colors } from 'styles/theme/colors';

export const Summary = styled(AccordionSummary)(({ theme }) => {
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;

  return {
    border: 'none',
    marginBottom: 1,
    minHeight: 40,
    '&.Mui-expanded': { minHeight: 40 },
    '&:hover': {
      backgroundColor: isDarkMode ? colors.grey56 : colors.primaryWhite,
    },
    '& .MuiAccordionSummary-content': {
      margin: '8px 0',
      '& .MuiTypography-root': {
        fontSize: 16,
        color: isDarkMode ? colors.baseGrey20 : colors.baseGrey80,
      },
      '&.Mui-expanded': { margin: '8px 0' },
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: -4,
      padding: 0,
    },
  };
});
